import { v4 as uuidv4 } from 'uuid'

import { MedicaoAnteriorModel } from '../model-medicoes'
import { MedicaoAnteriorAntropometriaFormModel } from './model-medicaoAnteriorAntropometria'

export function convertMedicaoAnteriorAntropometriaFormModelToMedicaoAnteriorModel(
  medicao: MedicaoAnteriorAntropometriaFormModel
): MedicaoAnteriorModel {
  return {
    id: uuidv4(),
    altura: medicao.altura,
    data: medicao.data,
    perimetroCefalico: medicao.perimetroCefalico,
    peso: medicao.peso,
  }
}
